const styles = {
  listItemAvatar: {
    borderRadius: '50%',
    bgcolor: 'bg.darkDisabled',
    height: '30px',
    width: '30px',
    minWidth: '0px',
    display: 'flex',
    margin: '0em 1em 1em 0'
  },
  loaWrapper: {
    bgcolor: 'text.primary',
    borderRadius: '8px',
    margin: '0 0 1em',
    paddingTop: '.55em'
  }
};

export default styles;
